import script from "./CentralArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./CentralArea.vue?vue&type=script&setup=true&lang=ts"

import "./CentralArea.vue?vue&type=style&index=0&id=5223b7f0&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/liulv-sound/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5223b7f0"]])

export default __exports__